export const ieo = {
  zzjx: '正在進行',
  rgjl: '認購紀錄',
  yjjs: '已經結束',
  sf: '先發',
  mjze: '募集總額',
  ckjz: '募款進度',
  tips_1: 'Biking Startup平台重磅上線，和Biking一同發掘財富密碼吧！ ',
  tips_2: '即將上線優質項目，盡情期待',
  jyjjks: '交易即將開始',
  ksjy: '開始交易',
  qjy: '去交易',
  xmmc: '項目名稱',
  xmfjs: '項目方介紹',
  syxm: '所有項目',
  banner_1: '全新推出區塊鏈專案首發平台',
  banner_2: 'Biking一起尋找區塊鏈黑馬，開啟財富自由之路',
  ywc: '已完成',
  rgsj: '認購時間：',
  zcz: '支持者',
  dqjd: '當下進度',
  yck: '已募款',
  sddb: '收到代幣',
  dff: '待發放',
  zwxm: '暫無項目',
  xq: '詳情',
  wksyr: '未開始預熱',
  yrz: '預熱中',
  jxz: '進行中',
  yjs: '已結束',
  ts: '提示',
  dbwfjy: '該代幣暫時無法交易',
  ckqtdb: '請查看其他代幣',
  xm: '項目',
  ksrg: '開始認購',
  yrg: '已認購',
  xmjs: '專案介紹',
  csjg: '初始價格',
  dbzl: '代幣總量：{amount}枚',
  cssz: '初始市值：{fdv}美金',
  xmcytj: '專案參與條件',
  cjygzh: '建立一個Biking帳號',
  yyzh: '已有帳戶，直接登入',
  dlzhjkcy: '登入帳號即可參與認購',
  dljkrg: '登入帳號即可認購',
  xhzc: '現貨資產',
  zcdy: '現貨資產 ≥ 10 USDT',
  rggz: '認購規則',
  rgcg: '認購成功',
  cgrgxm: '恭喜！ 你已成功認購專案！ ',
  fhsy: '返回首頁',
  cyrghd: '參與Biking Startup 認購活動',
  rgje: '認購金額',
  xhzcgz: '現貨資產估價',
  rgsm: '認購說明：',
  rgsm1: '1.個人認購金額為≥{amount1}USDT；≤{amount2}USDT；',
  rgsm2: "2.項目以資金投入比例等比例分配認購，若用戶認購金額大於實際分配的金額的代幣，認購結束後，剩餘的U將返還回現金帳戶",
  qd: '確定',
  dyr: '待預熱',
  rgdjs: '認購倒數計時',
  yrdjs: "預熱倒數",
  jykqdjs: '交易開啟倒數計時',
  qrg: '去認購',
  rgjebdy: '認購金額最少不低於{amount} USDT',
  rgjebgy: '認購金額最多不超過{amount} USDT',
  rgjeccdqjc: '認購金額超出目前資產金額',
  fxts1: "1. 新創專案仍處於初級階段， 專案的運作、專案的底層技術、法規環境等均可能有極大的風險。",
  fxts2: "2. 了解 Token 並對其固有風險進行評估需要掌握高級的技術和財經知識。",
  fxts3: "3. 受到技術、法律法規、市場和其他因素的影響， 您購買的 Token 價格可能會劇烈波動，價格可能會大幅降低或升高。",
  fxts4: "4. 由於Token 的底層技術或BIKING 交易平台的原因， 您購買的 Token 可能無法全部或部分提現。",
  sfpt: "區塊鏈專案首發平台",
  xmhzsq: "計畫合作申請",
  hdlx: "活動類型",
  yryq: "一人一簽",
  yrdq: "一人多簽",
  hdjg: "活動價格",
  hdsl: "活動數量",
  zqs: "總簽數",
  rgqs: "認購簽數",
  rgsl: "認購數量",
  mqsl: "每簽數",
  mrzgqs: "每人最高簽數",
  qian: "簽名",
  lian: "鏈",
  hdrgsm: "認購說明：中簽後認購，會根據所有中簽用戶隨機抽取中籤總數用戶。若認購失敗，中簽空投發放的同時會退回認購失敗使用的USDT。",
  jqqd: "盡情期待中簽結果",
  dbffkjy: "代幣發放後可交易",
  dzjgb: "待中簽公佈",
  dzq: "待中簽",
  ffzt: "分發狀態",
  dbff: "中簽代幣發放",
  yff: "已發放",
  wzq: "未中簽",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/tw.js